export const getImageUrl = (image: string) => {
  return `${process.env.REACT_APP_IMAGE_BASE_URL}/${image}`
}
